// extracted by mini-css-extract-plugin
export default {"CardsContainer":"People_CardsContainer__u5K6e"};